export const BorderRadiusIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M2 14V12.6667H3.33333V14H2ZM2 11.3333V10H3.33333V11.3333H2ZM2 8.66667V7.33333H3.33333V8.66667H2ZM2 6V4.66667H3.33333V6H2ZM2 3.33333V2H3.33333V3.33333H2ZM4.66667 14V12.6667H6V14H4.66667ZM4.66667 3.33333V2H6V3.33333H4.66667ZM7.33333 14V12.6667H8.66667V14H7.33333ZM10 14V12.6667H11.3333V14H10ZM12.6667 14V12.6667H14V14H12.6667ZM12.6667 11.3333V10H14V11.3333H12.6667ZM14 8.66667H12.6667V5.33333C12.6667 4.77778 12.4722 4.30556 12.0833 3.91667C11.6944 3.52778 11.2222 3.33333 10.6667 3.33333H7.33333V2H10.6667C11.5889 2 12.375 2.325 13.025 2.975C13.675 3.625 14 4.41111 14 5.33333V8.66667Z"
        fill="#1A2547"
      />
    </svg>
  );
};
